import { SelectControl } from '../controls/select-control.model';
import { UiColumn } from '../ui-column';

export class CurrencySelect extends SelectControl {

  timestamp: Date | null;

  constructor(id: string, label: string, value: any);
  constructor(id: string, label: string, values: Array<any>);
  constructor(...arr: any[]) {
    var id = arr[0];
    var label = arr[1];
    var values = arr[2];
    var data: Array<any> = [];

    var isArray = values instanceof Array;

    if (isArray) {
      data = values;
    } else {
      data.push(values);
    }

    super(id, label, data, isArray);

    this.apiController = "Currency";
    this.displayMember = "name";
    this.valueMember = "code";
    this.forceDataLoadOnOpen = true;
    this.columns = [
      new UiColumn("code", "Code", 100),
      new UiColumn("name", "Name", 200),
      new UiColumn("symbol", "Symbol", 100)
    ];
  }

}
